import { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { settingsStyles, headerSearchBoxStyles, headerSearchScopeStyles, headerScopeOptionStyles, appHeaderStyles, headerResizeGroupStyles, notificationButtonStyle, headerButtonIconStyle, settingsLabelStyles, getNotificationBadgeClass, getProfileCoinStyles } from "./AppHeader.styles";
import { CoherenceDataGrid, CoherenceDataGridColumn, CoherenceLoading, CoherenceNotificationType, Template } from "@coherence-design-system/controls";
import { loginRequest } from "../../authConfig";
import { CommandBar, DetailsListLayoutMode, FontIcon, IComboBox, IComboBoxOption, ICommandBarItemProps, Link, Persona,IContextualMenuProps,IPanel,Panel,PersonaSize,IContextualMenuItemProps, Pivot, PivotItem, ResizeGroup, TooltipHost ,  FontSizes,
  FontWeights,IconButton,ITheme,DefaultPalette, createTheme, ThemeProvider, ChoiceGroup, IChoiceGroupOption, Label, useTheme} from "@fluentui/react";
import { GetUserRole } from "../../utils/GetUserRole" 
import {  Category, EnhancedSearch, ICategory, IResult } from "@coherence-design-system/enhanced-search";
import { Header, HeaderButton, NotificationBadge, getTotalNewNotifications, usePanels, useResizeGroup } from '@coherence-design-system/header';
import { ProfileCenter } from "@coherence-design-system/profile-center";
import { FeedbackCenter } from "@coherence-design-system/feedback-center";
import { OPPApiHelper, isEmpty } from "../../utils/OPPApiHelper";
import ToastMessage from "../ToastMessage/ToastMessage"; 
import { useThemeMode, ThemeMode } from "../../contexts/ThemeContext";
import NotificationPanel from "../NotificationPanel/NotificationPanel";
import { useNotifications } from "../../contexts/NotificationContext";
import { getCurrentUserId, getCurrentUserName } from "../../utils/CurrentUser";
 

 export const AppHeader = () => {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [UserName, setName] = useState("");
  const [Email, setEmail] = useState("");
  const location = useLocation();
  const [isHeaderSearch, setIsHeaderSearch] = useState(false);
  const defaultUserName = getCurrentUserName();
  const defaultUserID = getCurrentUserId(); 
  const { themeMode, setThemeMode } = useThemeMode();
  const theme = useTheme();
  const [profilePhotoUrl, setProfilePhotoUrl] = useState<string>("");
  const [isNotificationPanelOpen, setIsNotificationPanelOpen] = useState(false);
  const { unreadCount } = useNotifications();

  const themeOptions: IChoiceGroupOption[] = [
    { key: "system", text: "System (Auto)" },
    { key: "light", text: "Light" },
    { key: "dark", text: "Dark" },
    { key: "high-contrast", text: "High Contrast" },
    { key: "teams-dark", text: "Teams Dark" },
    { key: "midnight-blue", text: "Midnight Blue" },
    { key: "warm-gray", text: "Warm Gray" },
    { key: "sand", text: "Sand" },
    { key: "sepia", text: "Sepia" },
    { key: "lavender-mist", text: "Lavender Mist" },
    { key: "rose", text: "Rose" },
    { key: "sunrise", text: "Sunrise" },
  ];

  const onThemeChange = (_ev?: React.FormEvent<HTMLElement>, option?: IChoiceGroupOption) => {
    if (option) {
      setThemeMode(option.key as ThemeMode);
    }
  };
  // Account setup and profile photo fetch — only when account changes
  useEffect(() => {
      const abortController = new AbortController();
      if (account) {
        if(account.name) {
          setName(account.name);
        }
        if(account.username) {
          setEmail(account.username);
        }
        // Fetch profile photo from Microsoft Graph
        instance.acquireTokenSilent({ ...loginRequest, account, scopes: ["User.Read"] })
          .then((response) => {
            fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
              headers: { Authorization: `Bearer ${response.accessToken}` },
              signal: abortController.signal,
            })
              .then((res) => {
                if (res.ok) return res.blob();
                throw new Error("No photo");
              })
              .then((blob) => {
                if (!abortController.signal.aborted) {
                  setProfilePhotoUrl(URL.createObjectURL(blob));
                }
              })
              .catch(() => { /* No profile photo available or request aborted, keep initials */ });
          })
          .catch(() => { /* Token acquisition failed, keep initials */ });
      } else {
          setName("");
          setEmail("");
      }

      return () => {
        abortController.abort();
      };
  }, [account, instance]);

  // Route-based header search toggle — only when location changes
  useEffect(() => {
      const routerName = location.pathname.split('/')[1];
      setIsHeaderSearch(routerName === "PORItems");
  }, [location]);

  useEffect(() => {
    return () => {
      if (profilePhotoUrl) URL.revokeObjectURL(profilePhotoUrl);
    };
  }, [profilePhotoUrl]);

    //header search code start
  // Define dropDownList
  const dropDownList: IComboBoxOption[] = [
    {key:'All', text: 'All'},
    {key:'PORID', text: 'PORID'},
    {key:'Title', text: 'Title'},
    {key:'MILAID', text: 'MILAID'},
    {key:'CTID', text: 'CTID'},
    {key:'OneMapID', text: 'OneMapID'},
    {key:'MLCID', text: 'MLCID'},
    {key:'RIMID', text: 'RIMID'},
    {key:'PFAM', text: 'PFAM'},
    {key:'SKU', text: 'SKU'}
  ];
  

  //  const categorizedNotifications = getCategorizedNotifications(theme);
  const [activeScope, setActiveScope] = React.useState(dropDownList[0].text);
  const [searchText, setSearchText] = React.useState('');
  const profileCenterRef = React.useRef<IPanel>(null);
  const feedbackCenterRef = React.useRef<IPanel>(null);
  const [isSettingsPanelOpen, setIsSettingsPanelOpen] = useState(false);
  const { currentPanel, openPanel, closePanel } = usePanels();

  // Auto-close settings when any Coherence panel opens
  useEffect(() => {
    if (currentPanel) {
      setIsSettingsPanelOpen(false);
      setIsNotificationPanelOpen(false);
    }
  }, [currentPanel]);
  const navigate = useNavigate();
 
    const onSaveSearch = (searchTextValue: string) => {
      let propsData= {
        "searchText": searchTextValue,
        "searchType": activeScope
     } 
     //Sending this props data to App.tsx file - to communicate with HeaderSearchResults file 
    navigate(`/SearchResult`,{ state: { searchData: propsData } });  
    onSearchClear();
    }

  

  const onSearchChange = (_event?: React.ChangeEvent<HTMLInputElement>, newSearchText?: string) => {
    setSearchText(newSearchText || '');
  };
  const onSearchClear = () => {
    setSearchText('');
  };
 // FeedBack/OCV Center
 const InitialFeedbackDataNoSurface = {
   callbackFunctions: {
     onDismiss: (_isFeedbackSent?: boolean) => {}
   }
 }; // Define or import this object as needed
 const ocvOptions = { ...InitialFeedbackDataNoSurface };
 ocvOptions.callbackFunctions.onDismiss = (_isFeedbackSent?: boolean) => {
   closePanel();
 };
 const profileProps = {
  Title: "Profile",
  persona: {
    imageUrl: profilePhotoUrl,
    text: UserName,
    secondaryText: Email,
    initialsColor: theme.palette.themePrimary,
  },
  actions: [ 
    {
      children: 'View account',
      onClick: (): void => {
        window.location.href = "https://myaccount.microsoft.com";
      },
    }
    
  ]
};
const _items = [
  {
    key: 'feedback',
    icon: 'Feedback',
    iconProps: { iconName: 'Feedback' },
    ariaLabel: 'Feedback',
    text: 'Feedback',
    onClick: (): void => {
      window.open("https://forms.office.com/r/VbPE5HZFuu",'Feedback Form');
    },
  },  
];
  const onSelectDropdown = React.useCallback((event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number) => {
      setActiveScope(option!.text);
    },
    []
    );
  const formattedData = {
    primary: _items,
    overflow: []
  };
const { onReduceData, onGrowData, onRenderData } = useResizeGroup({ closePanel, currentPanel });

const SharedEnhancedSearch =  (
  <EnhancedSearch
    minHighlightThreshold={1}
    id="standalone-enhancedsearch-with-searchscope"
    onSearch={onSaveSearch}
    onChange={onSearchChange}
    onClear={onSearchClear}
    value={searchText}
    isSearchInHeader={false}
    autoComplete="off"
    styles={headerSearchBoxStyles}
    searchScopeOptions={{
      autoComplete: 'off',
      onItemSelect: onSelectDropdown,
      selectedKey: activeScope,
      scopes: dropDownList.filter((scope: IComboBoxOption) => scope.key !== 'All'),
      styles: headerSearchScopeStyles,
      comboBoxOptionStyles: headerScopeOptionStyles,
    }}
  /> 
);

  // header search code end
  const isPreProdPME = process.env.REACT_APP_Evn === 'ppe';
  const isPreProd = process.env.REACT_APP_Evn === 'uat';
  const isDev = process.env.REACT_APP_Evn === 'dev';
  const envLabel = isPreProdPME ? "(Pre-Prod PME)" : isPreProd ? "(Pre-Prod)" : isDev ? "(Development)" : "";
  const notificationBadgeClass = getNotificationBadgeClass(theme);
  const profileCoinStyles = getProfileCoinStyles(theme);
  return (
    <>
      <div className={appHeaderStyles.headerRoot} role="banner">
        <Header 
          showHamburger={false}
        >
          <Template slot="title">
            <span className={appHeaderStyles.headerTitle}>
              <img src="/opp_logo.png" alt="OPP Logo" className={appHeaderStyles.headerLogo} />
              Offer Publishing | MLC {envLabel && <span className={appHeaderStyles.environmentLabel}>{envLabel}</span>}
            </span>
          </Template>
          {isHeaderSearch && <Template slot="search">{SharedEnhancedSearch}</Template>}
          <Template slot="collapsible-triggers">
            <ResizeGroup
              styles={headerResizeGroupStyles}
              data={formattedData}
              onReduceData={onReduceData}
              onGrowData={onGrowData}
              onRenderData={onRenderData}
            />
          </Template>
          <Template slot="static-triggers">
            <div className={appHeaderStyles.staticTriggers}>
              <TooltipHost content={'Notifications'} id={'notifications'}>
                <HeaderButton
                  onClick={() => { closePanel(); setIsSettingsPanelOpen(false); setIsNotificationPanelOpen(true); }}
                  aria-labelledby={'notifications'}
                  style={notificationButtonStyle}
                >
                  <FontIcon iconName="Ringer" style={headerButtonIconStyle} />
                  {unreadCount > 0 && (
                    <span className={notificationBadgeClass}>
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}
                </HeaderButton>
              </TooltipHost>
              <TooltipHost content={'Settings'} id={'settings'}>
                <HeaderButton
                  onClick={() => { closePanel(); setIsSettingsPanelOpen(true); }}
                  aria-labelledby={'settings'}
                >
                  <FontIcon iconName="Settings" style={headerButtonIconStyle} />
                </HeaderButton>
              </TooltipHost>
              <TooltipHost content={'profile'} id={'profile'}>
                <HeaderButton
                  onClick={() => { setIsSettingsPanelOpen(false); openPanel(profileCenterRef); }}
                  aria-labelledby={'profile'}
                >
                  <Persona
                    hidePersonaDetails={true}
                    size={PersonaSize.size28}
                    {...profileProps.persona}
                    initialsColor={theme.palette.themePrimary}
                  />
                </HeaderButton>
              </TooltipHost>
            </div>
          </Template>
        </Header>
      </div>
      {/* Panels live outside the header. */}
      <ProfileCenter
        componentRef={profileCenterRef}
        isOpen={Boolean(currentPanel === profileCenterRef)}
        isLightDismiss={true}
        onDismiss={() => closePanel()}
        {...profileProps}
        persona={{
          ...profileProps.persona,
          coinProps: {
            styles: profileCoinStyles,
          },
        }}
      />
      <Panel
        isOpen={isSettingsPanelOpen}
        onDismiss={() => setIsSettingsPanelOpen(false)}
        isLightDismiss={true}
        headerText="Settings"
      >
        <div className={appHeaderStyles.settingsPanelSection}>
          <Label styles={settingsLabelStyles}>Theme</Label>
          <ChoiceGroup
            selectedKey={themeMode}
            options={themeOptions}
            onChange={onThemeChange}
          />
        </div>
      </Panel>
      <FeedbackCenter
        componentRef={feedbackCenterRef}
        onDismiss={() => closePanel()}
        ocvOptions={ocvOptions}
        isOpen={Boolean(currentPanel === feedbackCenterRef)}
      />
      <NotificationPanel
        isOpen={isNotificationPanelOpen}
        onDismiss={() => setIsNotificationPanelOpen(false)}
      />
    </>
     
  );
};
export default AppHeader;
